import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent {
  @Input() id?: string;
  @Input() name?: string;
  @Input() value?: string;
  @Input() required?: boolean;
  @Input() disabled?: boolean;
  @Input() checked?: boolean;
  @Input() input?: {
    ariaDescribedby?: string;
    ariaLabelledby?: string;
    ariaHidden?: boolean;
  };
  @Input() tag = false;
  @Input() size?: 'small' | '' = '';

  @Output() checkboxChange = new EventEmitter<boolean>();

  onChange: any = () => {};
  onTouched: any = () => {};

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: any) {
    this.onChange(event.target.value);
    this.onTouched();
  }

  writeValue(checked: boolean): void {
    this.checked = checked;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const isChecked = target.checked;
    this.onChange(isChecked);
    this.checkboxChange.emit(isChecked);
  }
}
